export const QueryKeys = {
    GetAllPaymentAccounts: 'get-all-payment-accounts',
}
